import React from 'react';
import { Star, ShieldCheck, Zap } from 'lucide-react';
export function CtaSection() {
  return <section id="precio" className="bg-[#1A1A1A] text-white px-4 py-16 md:py-24" data-id="element-1">
      <div className="max-w-lg mx-auto flex flex-col items-center text-center gap-6" data-id="element-2">
        {/* Social Proof */}
        <div className="flex flex-col items-center gap-2" data-id="element-3">
          <div className="flex gap-1" data-id="element-4">
            {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-5 h-5 text-[#C5A059] fill-[#C5A059]" data-id="element-5" />)}
          </div>
          <p className="text-sm text-white/60 tracking-wide" data-id="element-6">
            4.9/5 de valoración de clientes
          </p>
        </div>

        {/* Headline */}
        <div className="space-y-3" data-id="element-7">
          <h2 className="text-4xl md:text-5xl font-serif text-white leading-tight" data-id="element-8">
            Eleva tu Estándar hoy
          </h2>
          <p className="text-sm md:text-base text-white/60 font-light leading-relaxed max-w-sm mx-auto" data-id="element-9">
            Únete a cientos de entusiastas que transformaron sus espacios de
            "común" a "editorial" con el método estructural.
          </p>
        </div>

        {/* Product Mockup + Pricing Card */}
        <div className="relative w-full bg-[#242424] rounded-2xl border border-white/10 px-6 pt-8 pb-8 mt-4 overflow-visible" data-id="element-10">
          {/* iPhone mockup — floats above the card */}

          {/* Spacer for mockup overlap */}
          <div className="h-6" data-id="element-11"></div>

          {/* Value Anchor */}
          <div className="flex items-center justify-center gap-2 mb-1" data-id="element-12">
            <span className="text-xs text-white/40 uppercase tracking-widest line-through" data-id="element-13">
              VALOR REAL: $27.00 USD
            </span>
          </div>

          {/* Price */}
          <div className="flex items-baseline justify-center gap-1 mb-6" data-id="element-14">
            <span className="text-5xl md:text-6xl font-bold text-[#C5A059] leading-none" data-id="element-15">
              $6.36
            </span>
            <span className="text-lg text-[#C5A059]/70 font-light" data-id="element-16">USD</span>
          </div>

          {/* CTA Button */}
          <a href="https://manosquegeneran.com/cart/48303873753315:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#C5A059] text-black font-bold text-base md:text-lg py-4 px-6 rounded-xl tracking-wide hover:bg-[#d4b06a] active:scale-[0.98] transition-all duration-200 uppercase text-center" data-id="element-17">
            OBTENER ACCESO INMEDIATO
          </a>

          {/* Trust Badges */}
          <div className="flex items-center justify-center gap-6 mt-5" data-id="element-18">
            <div className="flex items-center gap-1.5 text-white/50 text-xs" data-id="element-19">
              <ShieldCheck className="w-4 h-4 text-[#C5A059]/70" data-id="element-20" />
              <span data-id="element-21">Pago Seguro SSL</span>
            </div>
            <div className="flex items-center gap-1.5 text-white/50 text-xs" data-id="element-22">
              <Zap className="w-4 h-4 text-[#C5A059]/70" data-id="element-23" />
              <span data-id="element-24">Acceso Instantáneo</span>
            </div>
          </div>
        </div>

        {/* Micro-copy */}
        <p className="text-xs text-white/30 leading-relaxed max-w-xs" data-id="element-25">
          Compra final. Acceso de por vida inmediato al PDF tras el pago. Sin
          cuotas mensuales.
        </p>
      </div>
    </section>;
}